import {Box, Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import {supportedLngs, useSetLanguage} from "../i18n";
import {globalStyles} from "../styles/global.styles";

const flags = {
    de: "🇩🇪",
    en: "🇺🇸",
};

export default function LanguageSwitcher() {
    const {i18n} = useTranslation();
    const set = useSetLanguage();

    return (
        <Box sx={globalStyles.languageSwitcher.boxContainer}>
            {supportedLngs
                .filter((lang) => lang !== i18n.language)
                .map((language) => (
                    <Button
                        size="small"
                        key={language}
                        onClick={() => set(language)}
                        sx={globalStyles.languageSwitcher.switchButton}
                    >
                        {flags[language] ?? language}
                    </Button>
                ))}
        </Box>
    );
}
